module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/x-is-function/index.js
// module id = 144
// module chunks = 0